import {
  Grid,
  Box,
  Paper,
  Typography,
  TextField,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  InputAdornment,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo, useRef } from "react";
import { useApi } from "../../api/useApi";
import {
  MoreVert,
  Add,
  Search,
  ArrowBackIosNewRounded,
  ArrowForwardIosRounded,
} from "@mui/icons-material";
import adminLoginBg from "../../assets/images/background.png";
import Notification from "../Notification";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { API_PATH } from "../../environments";
import BackButton from "../BackButton";
const expectedColumns = [
  "Question ID",
  "Question",
  "Option Text",
  "Option Points",
  "User Role",
  "Recommendation",
  "Category",
  "Is Mandatory",
  "Domain",
  "Remarks",
];

export default function Questionaier() {
  const [questions, setQuestions] = useState([]);
  const { request, loading, error } = useApi();

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const [selected, setSelected] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { domain } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  const [notif, setNotif] = useState({
    open: false,
    success: true,
    text: "",
  });
  const fileInputRef = useRef(null);

  useEffect(() => {
    const fetchQuestions = async () => {
      let data;
      try {
        data = await request({ url: "/questions/all" });
        if (domain) {
          data = data.filter(
            (q) => q.domain.toLowerCase() === domain.toLowerCase()
          );
        }
        setQuestions(data);
      } catch (err) {
        console.error("Failed to fetch questions:", err);
      }
    };
    fetchQuestions();
  }, [request, domain]);

  const handleMoreMenuOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMoreMenuClose = () => {
    setAnchorEl(null);
    setAnchorElFilter(null);
  };

  const handleFilterMenuOpen = (e) => {
    setAnchorElFilter(e.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setAnchorElFilter(null);
  };

  const handleSelectDomain = (domain) => {
    setAnchorEl(null);
    setAnchorElFilter(null);
    navigate(`/admin/${domain}/questionaire`);
  };

  const handleDelete = () => {
    setAnchorEl(null);
    setDeleteDialog(true);
    setDeleteId(selected);
  };

  const handleEdit = (q = null) => {
    if (q) {
      setAnchorEl(null);
      navigate(`/admin/${domain}/edit-questionaire`, {
        state: { questions: [q] }
      })
    } else {
      const selectedQuestionIds = new Set(selected);
      const selectedQuestions = questions.filter(question => selectedQuestionIds.has(question.questionId))
      navigate(`/admin/${domain}/edit-questionaire`, {
        state: { questions: [...selectedQuestions] }
      })

    }

  };

  const handleDownload = () => {
    setAnchorEl(null);
    try {
      if (!questions || questions.length === 0) {
        setNotif({
          open: true,
          success: false,
          text: "Oops! No questions available to download.",
        });
        return;
      }

      const worksheetData = questions.map((q, idx) => ({
        "Question ID": q.questionId,
        "Question": q.question,
        "Option Text": q.optionText,
        "Option Points": q.optionPoints,
        "User Role": q.userRole,
        "Recommendation": q.recommendation,
        "Category": q.category,
        "Is Mandatory": q.questionIsMandatory ? "Yes" : "No",
        "Domain": q.domain,
        "Remarks": q.remarks,
        "User Domain Role": q.userDomainRole
      }));

      // Create worksheet & workbook
      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Questionnaire");

      // Auto-fit column widths
      const colWidths = Object.keys(worksheetData[0]).map((key) => ({
        wch: Math.max(
          key.length,
          ...worksheetData.map((row) =>
            row[key] ? row[key].toString().length : 0
          )
        ) + 2,
      }));
      worksheet["!cols"] = colWidths;

      // Export to excel
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(file, `questionnaire_${domain || "all"}.xlsx`);

      setNotif({
        open: true,
        success: true,
        text: "Congratulations! Questionnaire downloaded successfully 🎉",
      });
    } catch (err) {
      console.error("Download failed:", err);
      setNotif({
        open: true,
        success: false,
        text: "Oops! Failed to download questionnaire 😢",
      });
    }
  };

  const handleAddTemplate = () => {
    setAnchorElAdd(null);
    navigate(`/admin/${domain}/add-new-questionaire`)
  };


  // const handleUploadQuestionaire = (e) => {
  //   setAnchorElAdd(null);
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const allowedExtensions = ["xlsx", "xls"];
  //   const fileExtension = file.name.split(".").pop();
  //   if (!allowedExtensions.includes(fileExtension)) {
  //     alert("Please select a valid Excel file (.xlsx or .xls)");
  //     return;
  //   }

  //   const reader = new FileReader();
  //   reader.onload = (evt) => {
  //     const data = new Uint8Array(evt.target.result);
  //     const workbook = XLSX.read(data, { type: "array" });
  //     const firstSheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[firstSheetName];
  //     const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false, defval: "" });

  //     const fileColumns = jsonData[0];
  //     const expectedColumns = [
  //       "Question ID",
  //       "Question",
  //       "Option Text",
  //       "Option Points",
  //       "User Role",
  //       "Recommendation",
  //       "Category",
  //       "Is Mandatory",
  //       "Domain",
  //       "Remarks"
  //     ];

  //     const validColumns =
  //       fileColumns.length === expectedColumns.length &&
  //       fileColumns.every((col, idx) => col.trim() === expectedColumns[idx]);

  //     if (!validColumns) {
  //       alert("Excel file columns are invalid. Please check column names and count.");
  //       return;
  //     }

  //     const rows = jsonData.slice(1).filter((row) => row && row.some((cell) => String(cell).trim() !== ""));

  //     // 🧠 Split comma-separated options into arrays
  //     const formattedData = rows.map((row) => {
  //       const optionTexts = row[2].split(",").map((s) => s.trim());
  //       const optionPoints = row[3].split(",").map((s) => parseFloat(s.trim() || "0"));
  //       const recommendations = row[5].split(",").map((s) => s.trim());
  //       const remarks = row[9].split(",").map((s) => s.trim());

  //       const options = optionTexts.map((text, i) => ({
  //         optionText: text,
  //         optionPoints: optionPoints[i] || 0,
  //         recommendationText: recommendations[i] || "",
  //         remarks: remarks[i] || "",
  //       }));

  //       return {
  //         questionText: row[1],
  //         userRole: row[4],
  //         category: row[6],
  //         domain: row[8],
  //         questionIsMandatory: String(row[7]).toLowerCase() === "yes",
  //         options,
  //       };
  //     });

  //     console.log("📤 Final payload:", formattedData);

  //     // ✅ Send directly to backend
  //     request({
  //       url: "/questions/bulk-insert",
  //       method: "POST",
  //       data: formattedData,
  //     })
  //       .then(async () => {
  //         setNotif({ open: true, success: true, text: "Questions uploaded successfully 🎉" });
  //         // ⬇️ Refetch updated data
  //         const updated = await request({ url: "/questions/all" });
  //         setQuestions(updated);
  //       })
  //       .catch((err) => {
  //         console.error("Upload failed:", err);
  //         setNotif({ open: true, success: false, text: "Failed to upload questions 😢" });
  //       });

  //   };

  //   reader.readAsArrayBuffer(file);
  // };


  const handleUploadQuestionaire = (e) => {
    setAnchorElAdd(null);
    const file = e.target.files[0];
    if (!file) return;

    const allowedExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop();
    if (!allowedExtensions.includes(fileExtension)) {
      alert("Please select a valid Excel file (.xlsx or .xls)");
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        blankrows: false,
        defval: "",
      });

      if (!jsonData.length) {
        alert("Excel file is empty");
        return;
      }

      const fileColumns = jsonData[0].map((c) => c.trim());

      // Normalize column names
      const normalize = (str) =>
        str.replace(/\s+/g, " ").trim().toLowerCase();

      // Flexible header matching
      const expectedColumnPatterns = {
        "question": ["question", "questions", "question text", "quetion", "ques"],
        "option text": ["option text", "options", "option"],
        "option points": ["option points", "points", "option point"],
        "user role": ["user role", "role"],
        "recommendation": ["recommendation", "recommendations"],
        "category": ["category", "categorie", "catagory", "cat"],
        "is mandatory": ["is mandatory", "mandatory", "required"],
        "domain": ["domain"],
        "remarks": ["remarks", "remark", "notes"],
        "question id": ["question id", "id"], // optional
        "user Domain Role": ["user domain role", "userdomainrole"]
      };

      // Build flexible column mapper
      const columnMap = {};

      fileColumns.forEach((col, idx) => {
        const norm = normalize(col);
        Object.entries(expectedColumnPatterns).forEach(([key, patterns]) => {
          if (patterns.includes(norm)) {
            columnMap[key] = idx;
          }
        });
      });

      // Required columns (exclude Question ID)
      const requiredCols = [
        "question",
        "option text",
        "option points",
        "user role",
        "user Domain Role",
        "recommendation",
        "category",
        "is mandatory",
        "domain",
        "remarks",
      ];

      const missing = requiredCols.filter((col) => columnMap[col] === undefined);
      if (missing.length > 0) {
        alert("Missing required columns: " + missing.join(", "));
        return;
      }

      // Detect optional question ID
      const hasQuestionId = columnMap["question id"] !== undefined;

      const rows = jsonData.slice(1).filter((row) =>
        row.some((cell) => String(cell).trim() !== "")
      );

      const formattedData = rows.map((row) => {
        const optionTexts = row[columnMap["option text"]]
          .split(",")
          .map((s) => s.trim());

        const optionPoints = row[columnMap["option points"]]
          .split(",")
          .map((s) => parseFloat(s.trim() || "0"));

        const recommendations = row[columnMap["recommendation"]]
          .split(",")
          .map((s) => s.trim());

        const remarks = row[columnMap["remarks"]]
          .split(",")
          .map((s) => s.trim());
        const userDomainRole = row[columnMap["user Domain Role"]]
          .split(",")
          .map((s) => s.trim());
        const options = optionTexts.map((text, i) => ({
          optionText: text,
          optionPoints: optionPoints[i] ?? 0,
          recommendationText: recommendations[i] ?? "",
          remarks: remarks[i] ?? "",
          userDonamin: userDomainRole[i] ?? "",
        }));

        return {
          // Only send if present in sheet
          questionId:
            hasQuestionId &&
              row[columnMap["question id"]] &&
              String(row[columnMap["question id"]]).trim() !== ""
              ? Number(row[columnMap["question id"]])
              : null,

          questionText: row[columnMap["question"]],
          userRole: row[columnMap["user role"]],
          category: row[columnMap["category"]],
          domain: row[columnMap["domain"]],
          userDomainRoles: row[columnMap["user Domain Role"]]
  ? row[columnMap["user Domain Role"]].split("/").map(s => s.trim()).filter(Boolean)
  : [],
          questionIsMandatory:
            String(row[columnMap["is mandatory"]]).toLowerCase() === "yes",

          options,
        };
      });

      console.log("📤 Final Payload:", formattedData);

      request({
        url: "/questions/upload-excel-json",
        method: "POST",
        data: formattedData,
      })
        .then(async () => {
          setNotif({
            open: true,
            success: true,
            text: "Questions uploaded successfully 🎉",
          });

          const updated = await request({ url: "/questions/all" });
          setQuestions(updated);
        })
        .catch((err) => {
          console.error("Upload failed:", err);
          setNotif({
            open: true,
            success: false,
            text: "Failed to upload questions 😢",
          });
        });
    };

    reader.readAsArrayBuffer(file);
  };

  const filtered = useMemo(() => {
    return questions.filter((q) =>
      q.question.toLowerCase().includes(search.toLowerCase())
    );
  }, [questions, search]);

  useEffect(() => {
    const totalPages = Math.ceil(filtered.length / rowsPerPage);
    if (page > totalPages) {
      setPage(1);
    }
  }, [filtered, page, rowsPerPage]);

  const paginated = useMemo(() => {
    return filtered.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );
  }, [filtered, page]);

  // --- FIXED Select All ---
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // add only current page’s IDs
      setSelected((prev) => [
        ...prev,
        ...paginated
          .map((q) => q.questionId)
          .filter((id) => !prev.includes(id)),
      ]);
    } else {
      // remove only current page’s IDs
      setSelected((prev) =>
        prev.filter((id) => !paginated.some((q) => q.questionId === id))
      );
    }
  };

  const handleSelectOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        if (!domain) return;

        const res = await request({
          url: `/categories/by-domain?domain=${encodeURIComponent(domain)}`,

        });

        if (Array.isArray(res)) {
          setCategories(res);
        } else {
          console.warn("Unexpected category response:", res);
          setCategories([]);
        }
      } catch (err) {
        console.error("Failed to fetch categories:", err);
        setCategories([]);
      }
    };

    fetchCategories();
  }, [domain]);

  const handleSelectCategory = async (categoryName) => {
    try {
      setSelectedCategory(categoryName);
      setAnchorElFilter(null);
      setQuestions([]); // clear old data to show spinner if needed

      // http://localhost:8085/api/questions/filter/domain?domain=${encodeURIComponent
      const res = await request({
        // url: `https://devopssrescoreportal.sandhata.com/api/questions/filter/domain?domain=${encodeURIComponent(
        url: `${API_PATH}/questions/filter/domain?domain=${encodeURIComponent(
          domain
        )}&category=${encodeURIComponent(categoryName)}`,
      });

      if (Array.isArray(res)) {
        setQuestions(res);
      } else if (res.questions) {
        setQuestions(res.questions);
      } else {
        console.warn("Unexpected response:", res);
        setQuestions([]);
      }

      setNotif({
        open: true,
        success: true,
        text: `Filtered questions by "${categoryName}"`,
      });
    } catch (err) {
      console.error("Failed to fetch category questions:", err);
      setNotif({
        open: true,
        success: false,
        text: "Failed to load filtered questions.",
      });
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const data = Array.isArray(deleteId) ? deleteId : [deleteId];
      await request({ url: `/questions/bulk-delete`, method: "DELETE", data: data });
      setQuestions((prev) =>
        prev.filter((q) => !data.includes(q.questionId))
      );
      setNotif({
        open: true,
        success: true,
        text: `Deleted ${data.length} question(s) successfully`,
      });
    } catch (err) {
      console.error("Delete failed:", err);
      setNotif({
        open: true,
        success: false,
        text: "Failed to delete question(s)",
      });
    } finally {
      setDeleteDialog(false);
      setSelected([]);
      setDeleteId(null);
    }
  };

  return (
    <>
      <Grid
        container
        component="main"
        sx={{
          minHeight: "90vh",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        {/* Backgrounds */}
        {/* <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${adminLoginBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.2,
            zIndex: -1,
          }}
        /> */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            //  background:
            //   "conic-gradient(from -7.72deg at 100% 100%, #000000 0deg, #49454F 294.45deg, #000000 360deg)",
            //opacity: 1,
            // backdropFilter: "blur(20px) saturate(180%)",
            // WebkitBackdropFilter: "blur(12px) saturate(180%)",
            zIndex: -2,
          }}
        />

        {/* Main Card */}
        <Paper
          elevation={6}
          sx={{
            display: "flex",
            maxWidth: "77vw",
            width: "77vw",
            minHeight: { xs: "90vh", sm: "80vh", md: "85vh" },
            borderRadius: 4,
            overflow: "hidden",
            // background: "rgba(255,255,255,0.15)",
            // backdropFilter: "blur(5px)",
            flexDirection: "column",
            p: 2,
            flex: 1,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: "rgba(255,255,255,0.7)",
              borderRadius: 4,
              p: 0.5,
              pl: 3,
              mb: 2,
            }}
          >
            <BackButton/>
            <Typography variant="subtitle1">
              Existing Questions:{" "}
              <span style={{ color: "black" }}>
                {domain ? domain.toLocaleUpperCase() : "All Questions"}
              </span>
            </Typography>
          </Box>

          {/* Search + Actions */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,


            }}
          >
            <TextField
              size="small"
              placeholder="What are you looking for today?"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                },
              }}
              sx={{
                flex:1, 
                width: 300,
                mr: 5,
                backgroundColor: "#fff",

                "& .MuiOutlinedInput-root": {
                  height: "40px",
                  borderRadius: "24px",
                }
              }}
            />
            <FormControl 
              sx={{ 
                   flex: 1,
                    mr: 5,
                    backgroundColor: "#fff",

                    "& .MuiOutlinedInput-root": {
                      height: "40px",
                      borderRadius: "24px",
                      width: "350px",
                    }}}
            >
              <InputLabel id="category-filter-label">
                Filter By
              </InputLabel>

              <Select
                labelId="category-filter-label"
                value={selectedCategory || ""}
                label="Filter By"
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedCategory(value)
                  if (value === "ALL") {

                    request({ url: `/questions/all` }).then((data) => {
                      const filtered = data.filter(
                        (q) =>
                          q.domain.toLowerCase() === domain.toLowerCase()
                      );

                      setQuestions(filtered);
                    });
                  } else {
                    handleSelectCategory(value);
                  }
                }}
              >
                <MenuItem value="ALL">Show All</MenuItem>

                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <MenuItem
                      key={cat.id || cat.name}
                      value={cat.name}
                    >
                      {cat.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No categories found</MenuItem>
                )}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={(e) => setAnchorElAdd(e.currentTarget)}
              sx={{ mr: 2, borderRadius: 5 }}
            >
              Add New
            </Button>
            <IconButton
              sx={{ backgroundColor: "white" }}
              onClick={(e) => handleMoreMenuOpen(e)}
            >
              <MoreVert />
            </IconButton>
          </Box>

          {/* Table */}
          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              flex: 1,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "rgba(255,255,255,0.7)",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                "& .MuiTableRow-root:first-of-type": {
                  transition: "box-shadow 0.3s ease",
                },
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <colgroup>
                <col style={{ width: "8%" }} />  {/* Checkbox */}
                <col style={{ width: "8%" }} />  {/* S.No. */}
                <col style={{ width: "62%" }} /> {/* Question */}
                <col style={{ width: "11%" }} /> {/* Edit */}
                <col style={{ width: "11%" }} /> {/* Delete */}
              </colgroup>

              <TableHead
                sx={{
                  "& th": { fontWeight: "bold" },
                  zIndex: 1,
                }}
              >
                <TableRow
                  className="table-header"
                  sx={{
                    boxShadow: 0,
                    transition: "box-shadow 0.3s ease",
                  }}
                >
                  <TableCell
                    sx={{ backgroundColor: "rgba(255,255,255,0.5)" }}
                    padding="checkbox"
                  >
                    <Checkbox
                      checked={
                        paginated?.length > 0 &&
                        paginated.every((q) => selected.includes(q.questionId))
                      }
                      indeterminate={
                        paginated?.some((q) => selected.includes(q.questionId)) &&
                        !paginated.every((q) => selected.includes(q.questionId))
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>

                  {/* 🆕 Added S.No. Column */}
                  <TableCell sx={{ backgroundColor: "rgba(255,255,255,0.5)" }}>
                    S.No.
                  </TableCell>

                  <TableCell sx={{ backgroundColor: "rgba(255,255,255,0.5)" }}>
                    Questionnaire
                  </TableCell>

                  <TableCell sx={{ backgroundColor: "rgba(255,255,255,0.5)" }}>
                    Edit
                  </TableCell>

                  <TableCell sx={{ backgroundColor: "rgba(255,255,255,0.5)" }}>
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>

            {/* Scrollable Body */}
            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                "&::-webkit-scrollbar": { width: "6px", height: "6px" },
                "&::-webkit-scrollbar-thumb": {
                  borderRadius: "12px",
                  opacity: 0,
                  transition: "opacity 0.3s",
                },
                "&:hover::-webkit-scrollbar-thumb": {
                  opacity: 1,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#f5f5f5",
                  borderRadius: "12px",
                },
              }}
              onScroll={(e) => {
                const header =
                  e.currentTarget.previousSibling.querySelector(".table-header");
                if (header) {
                  header.style.boxShadow =
                    e.currentTarget.scrollTop > 0
                      ? "0 2px 6px rgba(0,0,0,0.15)"
                      : "none";
                }
              }}
            >
              <Table
                size="small"
                sx={{
                  tableLayout: "fixed",
                  width: "100%",
                  height: "60vh",
                }}
              >
                <colgroup>
                  <col style={{ width: "8%" }} />  {/* Checkbox */}
                  <col style={{ width: "8%" }} />  {/* S.No. */}
                  <col style={{ width: "62%" }} /> {/* Question */}
                  <col style={{ width: "11%" }} /> {/* Edit */}
                  <col style={{ width: "11%" }} /> {/* Delete */}
                </colgroup>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ height: "40vh", p: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <CircularProgress size={32} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                  {!loading && error && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        <Typography color="error">
                          Failed to load questions
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}

                  {!loading &&
                    !error &&
                    paginated?.map((q, index) => (
                      <TableRow key={q.questionId} hover>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selected.includes(q.questionId)}
                            onChange={() => handleSelectOne(q.questionId)}
                          />
                        </TableCell>

                        {/* 🆕 Added S.No. logic */}
                        <TableCell>{(page - 1) * rowsPerPage + index + 1}</TableCell>

                        <TableCell>{q.question}</TableCell>

                        <TableCell>
                          <Button
                            color="primary"
                            size="small"
                            onClick={() => handleEdit(q)}
                            sx={{
                              justifyContent: "flex-start",
                              pl: "0px",
                            }}
                          >
                            Edit
                          </Button>
                        </TableCell>

                        <TableCell>
                          <Button
                            color="error"
                            size="small"
                            onClick={() => {
                              setDeleteDialog(true);
                              setDeleteId(q.questionId);
                            }}
                            sx={{
                              justifyContent: "flex-start",
                              pl: "0px",
                            }}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}

                  {!loading && !error && paginated?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No questions found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </TableContainer>

          {/* Pagination */}
          {filtered.length !== 0 && filtered.length > rowsPerPage && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
              gap: 1,
            }}
          >
            {/* Previous */}
            <IconButton
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
              sx={{
                backgroundColor:
                  page === 1 ? "#f5f5f5" : "#1976d2",
                color:
                  page === 1 ? "#bdbdbd" : "#fff",
                "&:hover": {
                  backgroundColor:
                    page === 1 ? "#f5f5f5" : "#1565c0",
                },
              }}
            >
              <ArrowBackIosNewRounded fontSize="small" />
            </IconButton>

            {/* Page Numbers */}
            {Array.from(
              { length: Math.ceil(filtered.length / rowsPerPage) },
              (_, i) => (
                <Button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  sx={{
                    minWidth: "40px",
                    height: "40px",
                    borderRadius: "8px",

                    backgroundColor:
                      page === i + 1
                        ? "#1976d2"
                        : "transparent",

                    color:
                      page === i + 1
                        ? "#fff"
                        : "#000",

                    fontWeight:
                      page === i + 1
                        ? "bold"
                        : "normal",

                    border:
                      page === i + 1
                        ? "none"
                        : "1px solid #ddd",

                    "&:hover": {
                      backgroundColor:
                        page === i + 1
                          ? "#1565c0"
                          : "#f5f5f5",
                    },
                  }}
                >
                  {i + 1}
                </Button>
              )
            )}

            {/* Next */}
            <IconButton
              disabled={
                page >=
                Math.ceil(filtered.length / rowsPerPage)
              }
              onClick={() => setPage((p) => p + 1)}
              sx={{
                backgroundColor:
                  page >=
                  Math.ceil(filtered.length / rowsPerPage)
                    ? "#f5f5f5"
                    : "#1976d2",

                color:
                  page >=
                  Math.ceil(filtered.length / rowsPerPage)
                    ? "#bdbdbd"
                    : "#fff",

                "&:hover": {
                  backgroundColor:
                    page >=
                    Math.ceil(filtered.length / rowsPerPage)
                      ? "#f5f5f5"
                      : "#1565c0",
                },
              }}
            >
              <ArrowForwardIosRounded fontSize="small" />
            </IconButton>
          </Box>
        )}
        </Paper>

        {/* Menus + Dialogs */}
        <Menu
          id="add-new-button-menu"
          slotProps={{
            list: {
              "aria-labelledby": "add-new-button-menu",
            },
          }}
          anchorEl={anchorElAdd}
          open={Boolean(anchorElAdd)}
          onClose={() => setAnchorElAdd(null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleAddTemplate}>Add template</MenuItem>
          <>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".xlsx,.xls"
              onChange={handleUploadQuestionaire} // <-- your method
            />
            <MenuItem onClick={() => { fileInputRef.current.click(); }}>
              Upload questionaire
            </MenuItem>
          </>
        </Menu>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMoreMenuClose}
          slotProps={{
            list: {
              onMouseLeave: handleMoreMenuClose,
            },
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          

          <MenuItem disabled={!selected.length} onClick={() => handleEdit()}>
            Edit
          </MenuItem>
          <MenuItem disabled={!selected.length} onClick={handleDelete}>
            Delete
          </MenuItem>
          <MenuItem onClick={handleDownload}>Download questionaire</MenuItem>
        </Menu>

        <Dialog open={deleteDialog} onClose={() => setDeleteDialog(false)}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {`Are you sure you want to delete ${(Array.isArray(deleteId) && deleteId.length > 1) ? `${deleteId.length} questions` : "this question"} ?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} disabled={loading}>Cancel</Button>
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <Button
                color="error"
                onClick={handleDeleteConfirm}
                disabled={loading}
                variant="contained"
                sx={{
                  opacity: loading ? 0.5 : 1, // fade out when loading
                }}
              >
                Confirm Delete
              </Button>

              {loading && (
                <CircularProgress
                  size={24}
                  color="error"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </DialogActions>
        </Dialog>
      </Grid>
      <Notification
        open={notif.open}
        success={notif.success}
        text={notif.text}
        onClose={() => setNotif((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
}